module.exports = "<svg id=\"124285c6-c931-4779-b959-8e4d1f1c7aa1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>facebook</title><path d=\"M26.64,42.8V27.31h1.79c1,0,2,0,2.94,0,.16,0,.42-.19.44-.32.27-1.89.51-3.78.76-5.73H26.71c0-1.67-.09-3.28,0-4.88a1.84,1.84,0,0,1,1.93-1.79c.92-.09,1.85-.08,2.77-.11.42,0,.85,0,1.3,0V9.07c-.29,0-.58-.09-.87-.1-2.18-.11-4.37-.39-6.51.26a6.77,6.77,0,0,0-4.91,6.09c-.12,1.73-.08,3.48-.12,5.22,0,.22,0,.44,0,.71H15.16v6H20.3V42.76Z\"></path><path d=\"M49,1V48.84H.75V1H49m1-1H-.25V49.84H50V0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Facebook.svg
// module id = 0RnZ
// module chunks = 1